// extracted by mini-css-extract-plugin
module.exports = {"main":"AlertModal_main__6dKs0","btnArea":"AlertModal_btnArea__2ID0s","header":"AlertModal_header__tEbLJ","okBtn":"AlertModal_okBtn__1rZVu"};